import React from 'react';
import { 
  Box, Container, Group, Title, Button, Select, Text, ActionIcon, 
  TextInput, Paper, Grid, Stack, Tabs, Textarea, Switch, Checkbox, 
  Anchor, Modal, ScrollArea, ColorInput, Avatar 
} from '@mantine/core';
import { 
  IconExternalLink, IconCopy, IconRocket, IconPhoto, IconX, 
  IconMapPin, IconMail, IconBriefcase, IconRobot, IconCode 
} from '@tabler/icons-react';
import { QRCodeSVG } from 'qrcode.react';
import LocationPicker from './LocationPicker';
import { LivePreviewChat } from './App';

const WebsiteBuilderTab = ({ 
  authPageBg, setAuthPageBg, handleOnboard, t, handleOpenLivePreview, i18n, authLogo, setAuthLogo, 
  authLogoModalOpen, setAuthLogoModalOpen, authLogoPrompt, setAuthLogoPrompt, isAuthGeneratingLogo, generateAuthLogoImage, authEmail, setAuthEmail, authImageModalOpen, setAuthImageModalOpen, authHeaderImagePrompt, setAuthHeaderImagePrompt, isAuthGeneratingImage, generateAuthHeaderImage, authHeaderColor, setAuthHeaderColor, authHeaderImage, setAuthHeaderImage, authCompanyName, setAuthCompanyName, authLocation, setAuthLocation, authServices, setAuthServices, companyDesc, setCompanyDesc, authMapLat, setAuthMapLat, authMapLng, setAuthMapLng, authCalendarEnabled, setAuthCalendarEnabled, authAffiliateEnabled, setAuthAffiliateEnabled, authAffiliateCode, setAuthAffiliateCode, termsModalOpened, setTermsModalOpened, termsAccepted, setTermsAccepted, authError, user, setIsRegistering, setAuthError, setAuthPin, authCustomDomain, setAuthCustomDomain, authCustomHtml, setAuthCustomHtml
}) => {
  return (
          <Box bg={authPageBg} style={{ height: "100%", overflowY: "auto" }}>
                <form onSubmit={handleOnboard}>
                  {/* Admin Toolbar */}
                  <Box p="md" style={{ backgroundColor: "#1e293b", color: "white" }}>
                    <Container size="xl">
                      <Group justify="space-between">
                        <Group gap="sm">
                          <Title order={5}>{t("live_editor_title")}</Title>
                          <Button size="xs" variant="filled" color="yellow" c="black" fw={700} leftSection={<IconExternalLink size={16}/>} onClick={handleOpenLivePreview}>
                            {t("preview_btn_top", "👁️ Preview (New Window)")}
                          </Button>
                        </Group>
                        <Group>
    
                          <Select 
    
                            size="xs"
    
                            value={i18n.language?.substring(0, 2) || 'pl'}
    
                            onChange={(val) => i18n.changeLanguage(val)}
    
                            data={[
    
                              { value: 'en', label: 'EN' },
    
                              { value: 'pl', label: 'PL' },
    
                              { value: 'de', label: 'DE' },
    
                              { value: 'fr', label: 'FR' },
    
                              { value: 'es', label: 'ES' },
    
                              { value: 'it', label: 'IT' },
    
                              { value: 'pt', label: 'PT' },
    
                              { value: 'nl', label: 'NL' },
    
                              { value: 'sv', label: 'SV' },
    
                              { value: 'cs', label: 'CS' }
    
                            ]}
    
                            styles={{ input: { backgroundColor: 'rgba(255,255,255,0.1)', color: 'white', border: 'none', width: '80px' }, label: { color: 'white' } }}
    
                            label="Language"
    
                          />
    
                          <ColorInput size="xs" label="Header Color" value={authHeaderColor} onChange={setAuthHeaderColor} styles={{ label: { color: 'white' } }} />
    
                          <ColorInput size="xs" label="Page BG" value={authPageBg} onChange={setAuthPageBg} styles={{ label: { color: 'white' } }} />
    
                          <TextInput size="xs" label="Custom Domain" placeholder="e.g. yoursite.com" value={authCustomDomain} onChange={(e) => setAuthCustomDomain(e.currentTarget.value)} styles={{ label: { color: 'white' } }} mt="md"/>
    
                          <Button size="xs" variant="light" color="gray" onClick={() => document.getElementById('auth-header-upload').click()} leftSection={<IconPhoto size={14}/>}>Upload</Button>
    
                          <input id="auth-header-upload" type="file" hidden accept="image/*" onChange={(e) => {
    
                            const file = e.target.files[0];
    
                            if (file) {
    
                              const reader = new FileReader();
    
                              reader.onloadend = () => setAuthHeaderImage(reader.result);
    
                              reader.readAsDataURL(file);
    
                            }
    
                          }} />
    
                          
    
                          {/*
    
                          <Button size="xs" variant="light" color="indigo" onClick={() => {
    
                            if (!authEmail || !authEmail.trim()) {
    
                              alert(t('ai_image_email_req'));
    
                            } else {
    
                              setAuthImageModalOpen(true);
    
                            }
    
                          }} leftSection={<IconRobot size={14}/>}>AI Image</Button>
    
                          */}
    
                          <Button size="xs" variant="light" color="gray" onClick={() => document.getElementById('auth-logo-upload').click()} leftSection={<IconPhoto size={14}/>}>Upload Logo</Button>
    
                          <input id="auth-logo-upload" type="file" hidden accept="image/*" onChange={(e) => {
    
                            const file = e.target.files[0];
    
                            if (file) {
    
                              const reader = new FileReader();
    
                              reader.onloadend = () => setAuthLogo(reader.result);
    
                              reader.readAsDataURL(file);
    
                            }
    
                          }} />
    
                          {/*
    
                          <Button size="xs" variant="light" color="indigo" onClick={() => {
    
                            if (!authEmail || !authEmail.trim()) {
    
                              alert(t('ai_image_email_req'));
    
                            } else {
    
                              setAuthLogoModalOpen(true);
    
                            }
    
                          }} leftSection={<IconRobot size={14}/>}>AI Logo</Button>
    
                          */}
    
                        </Group>
    
                      </Group>
    
                    </Container>
    
                  </Box>
    
    
    
                                  <Modal opened={authLogoModalOpen} onClose={() => setAuthLogoModalOpen(false)} title="Generate AI Logo">
    
                      <Text size="sm" mb="md" c="dimmed">Describe the logo you want to generate. Be specific about shapes, colors, and style (e.g. Minimalist blue tech logo).</Text>
    
                      <Textarea 
    
                        placeholder="e.g. Minimalist blue tech logo with a cloud symbol"
    
                        value={authLogoPrompt}
    
                        onChange={(e) => setAuthLogoPrompt(e.currentTarget.value)}
    
                        minRows={3}
    
                      />
    
                      <Button 
    
                        mt="md" 
    
                        fullWidth 
    
                        color="indigo" 
    
                        loading={isAuthGeneratingLogo}
    
                        onClick={() => generateAuthLogoImage(authEmail, authLogoPrompt)}
    
                      >
    
                        Generate Logo
    
                      </Button>
    
                    </Modal>
    
                    <Modal opened={authImageModalOpen} onClose={() => setAuthImageModalOpen(false)} title={t('ai_image_title')}>
    
                    <Text size="sm" mb="md">{t('ai_image_desc')}</Text>
    
                    <Textarea 
    
                      placeholder={t('ai_image_prompt_placeholder')}
    
                      value={authHeaderImagePrompt}
    
                      onChange={(e) => setAuthHeaderImagePrompt(e.currentTarget.value)}
    
                      minRows={3}
    
                    />
    
                    <Button 
    
                      mt="md" 
    
                      fullWidth 
    
                      color="indigo" 
    
                      loading={isAuthGeneratingImage}
    
                      onClick={() => generateAuthHeaderImage(authEmail, authHeaderImagePrompt)}
    
                    >
    
                      {t('ai_image_btn')}
    
                    </Button>
    
                  </Modal>
    
    
    
                  {/* Header / Hero */}
    
                  <Box style={{ 
    
                    backgroundColor: authHeaderColor, 
    
                    backgroundImage: authHeaderImage ? `url(${authHeaderImage})` : 'none',
    
                    backgroundSize: 'cover',
    
                    backgroundPosition: 'center',
    
                    padding: '16px 20px', 
    
                    color: 'white', 
    
                    textAlign: 'center',
    
                    position: 'relative'
    
                  }}>
    
                    {authHeaderImage && <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.4)' }} />}
    
                                      <Container size="lg" style={{ position: 'relative', zIndex: 1 }}>
    
                        {authLogo && (
    
                          <Avatar size={100} radius={100} mx="auto" mb="md" src={authLogo} style={{ border: '4px solid white', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }} />
    
                        )}
    
                      <TextInput 
    
                        variant="unstyled" 
    
                        size="xl" 
    
                        styles={{ input: { fontSize: '2.5rem', fontWeight: 800, color: 'white', textAlign: 'center', borderBottom: '1px dashed rgba(255,255,255,0.5)', padding: 0 } }} 
    
                        placeholder="Your Company Name" 
    
                        value={authCompanyName} onChange={e => setAuthCompanyName(e.target.value)} 
    
                        required 
    
                      />
    
                      <Group justify="center" mt="md" gap="xl">
    
                        <Group gap={5}>
    
                          <IconMapPin size={16} color="white"/>
    
                          <TextInput variant="unstyled" placeholder="Location (e.g. Warsaw)" value={authLocation} onChange={e => setAuthLocation(e.target.value)} required styles={{ input: { color: 'white', borderBottom: '1px dashed rgba(255,255,255,0.5)', textAlign: 'center', width: '150px' } }} />
    
                        </Group>
    
                        {!true && (
    
                          <Group gap={5}>
    
                            <IconMail size={16} color="white"/>
    
                            <TextInput type="email" variant="unstyled" placeholder="Email Address" value={authEmail} onChange={e => setAuthEmail(e.target.value)} required disabled={true} styles={{ input: { color: 'white', borderBottom: '1px dashed rgba(255,255,255,0.5)', textAlign: 'center', width: '200px' } }} />
    
                          </Group>
    
                        )}
    
                      </Group>
    
                    </Container>
    
                  </Box>
    
    
    
                  <Container size="lg" py="xl">
    
                    <Grid gutter="xl">
    
                      <Grid.Col span={{ base: 12, md: 7 }}>
    
                        <Stack gap="xl">
    
                          <Tabs defaultValue="services" color="indigo" variant="outline" style={{ backgroundColor: '#141517', borderRadius: '8px', padding: '20px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
    
                            <Tabs.List mb="md">
    
                              <Tabs.Tab value="services" leftSection={<IconRocket size={16}/>}>{t('our_services')}</Tabs.Tab>
                              <Tabs.Tab value="customHtml" leftSection={<IconCode size={16}/>}>{t('custom_html_template', 'HTML Template')}</Tabs.Tab>
    
                            </Tabs.List>
    
                            <Tabs.Panel value="services">
    
                              <Stack gap="md">
    
                                {authServices.map((srv, index) => (
    
                                   <Paper key={index} p="md" radius="sm" withBorder bg="#0a0a0a">
    
                                      <Group align="flex-start" wrap="nowrap">
    
                                        <Stack gap="xs" style={{ flexGrow: 1 }}>
    
                                          <TextInput variant="unstyled" fw={700} placeholder={t('service_name')} value={srv.name} onChange={e => { const n = [...authServices]; n[index].name = e.target.value; setAuthServices(n); }} required styles={{ input: { borderBottom: '1px dashed #2f3032', fontSize: '1.1rem', padding: 0 } }} />
    
                                            <TextInput variant="unstyled" placeholder={t('brief_desc')} value={srv.description} onChange={e => { const n = [...authServices]; n[index].description = e.target.value; setAuthServices(n); }} styles={{ input: { borderBottom: '1px dashed #2f3032', padding: 0 } }} />
    
                                            <Group gap="xs" mt="sm">
    
                                              <IconPhoto size={16} color="#94a3b8" />
    
                                              <input type="file" accept="image/*" style={{ fontSize: '0.8rem', color: '#a1a1aa' }} onChange={(e) => {
    
                                                const file = e.target.files[0];
    
                                                if (file) {
    
                                                  const reader = new FileReader();
    
                                                  reader.onloadend = () => {
    
                                                    const n = [...authServices];
    
                                                    n[index].imageUrl = reader.result;
    
                                                    setAuthServices(n);
    
                                                  };
    
                                                  reader.readAsDataURL(file);
    
                                                }
    
                                              }} />
    
                                              {srv.imageUrl && <ActionIcon size="sm" color="red" variant="subtle" onClick={() => { const n = [...authServices]; n[index].imageUrl = null; setAuthServices(n); }}><IconX size={14} /></ActionIcon>}
    
                                            </Group>
    
                                            {srv.imageUrl && <img src={srv.imageUrl} alt="preview" style={{ maxHeight: '100px', objectFit: 'contain', marginTop: '8px', borderRadius: '4px' }} />}
    
                                          </Stack>
    
                                        <ActionIcon color="red" variant="outline" onClick={() => { const n = authServices.filter((_, i) => i !== index); setAuthServices(n.length ? n : [{name:'', description:''}]); }}><IconX size={16}/></ActionIcon>
    
                                      </Group>
    
                                   </Paper>
    
                                ))}
    
                                <Button variant="light" color="indigo" onClick={() => setAuthServices([...authServices, { name: '', description: '' }])}>{t('add_service')}</Button>
    
                              </Stack>
    
                                                        <Tabs.Panel value="customHtml">
                              <Stack gap="md">
                                <Text size="sm" c="dimmed">
                                  {t('custom_html_desc', 'Edytuj strukturę HTML swojej strony. Możesz użyć znaczników: {{companyName}}, {{description}}, {{services}}.')}
                                </Text>
                                <Textarea 
                                  variant="unstyled"
                                  minRows={15}
                                  autosize
                                  placeholder="<div>\n  <h1>{{companyName}}</h1>\n  <p>{{description}}</p>\n</div>"
                                  value={authCustomHtml || ''}
                                  onChange={(e) => setAuthCustomHtml(e.currentTarget.value)}
                                  styles={{ input: { border: '1px solid #cbd5e1', padding: '15px', borderRadius: '8px', backgroundColor: '#1e293b', color: '#38bdf8', fontFamily: 'monospace', fontSize: '13px', lineHeight: '1.5' } }}
                                />
                              </Stack>
                            </Tabs.Panel>
</Tabs.Panel>
    
                          </Tabs>
    
    
    
                          <Paper p="xl" radius="md" style={{ backgroundColor: '#141517', border: '1px solid #333', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
    
                            <Group gap="sm" mb="md"><Title order={4} style={{ color: 'white' }}>{t('about_us')}</Title></Group>
    
                            <Textarea 
    
                              variant="unstyled"
    
                              placeholder={t('about_us_placeholder')} 
    
                              minRows={11}
    
                              autosize
    
                              value={companyDesc} onChange={e => setCompanyDesc(e.target.value)}
    
                              required
    
                              styles={{ input: { border: '1px dashed #444', padding: '10px', borderRadius: '8px', backgroundColor: '#1a1b1e' } }}
    
                            />
    
                              
    
                            </Paper>
    
    
    
                            <Paper p="md" radius="md" withBorder mt="md" mb="md" style={{ background: '#141517', border: '1px solid #333', boxShadow: 'none' }}>
    
                              <Group justify="space-between" align="center" wrap="nowrap">
    
                                <Box style={{ flex: 1 }}>
    
                                  <Box mb="md">
    
                                    <Switch 
    
                                      label={t('enable_calendar', 'Włącz moduł kalendarza AI')} 
    
                                      description={t('enable_calendar_desc', 'Pozwól asystentowi sprawdzać dostępność i zapisywać spotkania/wizyty w Twoim kalendarzu')}
    
                                      checked={authCalendarEnabled} 
    
                                      onChange={(e) => setAuthCalendarEnabled(e.currentTarget.checked)} 
    
                                      mb="md" 
    
                                    />
    
                                  </Box>
    
                                  <Title order={5} c="green.9" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    
                                    🤝 {t('affiliate_opt_in_title', 'Dołącz do Programu Partnerskiego (Affiliate)')}
    
                                  </Title>
    
                                  <Text size="xs" c="green.8" mt="4px">
    
                                    {t('affiliate_opt_in_desc', 'Aktywuj program partnerski dla swojej firmy od samego początku. Zarabiaj prowizje za polecanie platformy AILinkB i buduj swoją sieć kontaktów B2B.')}
    
                                  </Text>
    
                                </Box>
    
                                <Switch 
    
                                  size="lg" 
    
                                  color="green" 
    
                                  checked={authAffiliateEnabled} 
    
                                  onChange={(e) => setAuthAffiliateEnabled(e.currentTarget.checked)} 
    
                                  style={{ cursor: 'pointer' }}
    
                                />
    
                              </Group>
    
                            </Paper>
    
    
    
                          <Box mt="md">
    
                            {!true && (
    
                              <Checkbox 
    
                                label={<Text size="sm">{t('chat_consent_label')} <Anchor size="sm" onClick={(e) => { e.preventDefault(); setTermsModalOpened(true); }}>{t('privacy_policy_link')}</Anchor></Text>}
    
                                checked={termsAccepted} onChange={(event) => setTermsAccepted(event.currentTarget.checked)}
    
                                mb="md"
    
                              />
    
                            )}
    
                            {!true && (
    
                              <TextInput 
    
                                label="Affiliate Code (Optional)" 
    
                                placeholder="If someone referred you" 
    
                                value={authAffiliateCode}
    
                                onChange={(e) => setAuthAffiliateCode(e.target.value)}
    
                                mb="sm"
    
                              />
    
                            )}
    
                            
    
                            {authError && <Text size="sm" c="red.6" mb="sm">{authError}</Text>}
    
                            <Button variant="light" color="yellow" c="black" size="md" fullWidth mb="sm" fw={700} leftSection={<IconExternalLink size={18}/>} onClick={handleOpenLivePreview}>{t('preview_btn_bottom', '👁️ Live Website Preview (New Window)')}</Button>
    
                            <Button type="submit" size="xl" fullWidth color="indigo" loading={authError === 'Setting up your AI...' || authError === 'Updating profile...'} leftSection={<IconBriefcase size={20}/>} disabled={(!termsAccepted && !true) || !authEmail || !companyDesc}>{true ? t('save_profile', 'Save Profile') : t('save_profile_activate', 'Save Profile & Activate AI')}</Button>
    
                            {!true && <Button variant="subtle" color="gray" fullWidth mt="sm" onClick={() => { setIsRegistering(false); setAuthError(''); setAuthPin(''); }}>{t('have_account_login', 'Masz już konto? Przejdź do logowania')}</Button>}
    
                          </Box>
    
                        </Stack>
    
                      </Grid.Col>
    
    
    
                      <Grid.Col span={{ base: 12, md: 5 }}>
    
                        <Box style={{ position: 'sticky', top: '20px' }}>
    
                          <Title order={4} mb="md" style={{ color: 'white', display: 'flex', alignItems: 'center', gap: '8px' }}><IconRobot size={24}/> {t('live_ai_chat')}</Title>
    
                          <Paper radius="md" style={{ height: '400px', border: '1px solid #333', overflow: 'hidden', boxShadow: '0 10px 25px -5px rgba(0,0,0,0.1)' }}>
    
                             <LivePreviewChat companyName={authCompanyName} services={authServices} aboutUs={companyDesc} headerColor={authHeaderColor} />
    
                          </Paper>
    
                          <Text size="xs" c="dimmed" mt="xs" mb="lg" ta="center">{t('ai_learn_note')}</Text>
    
    
    
                          {authEmail && (
    
                            <Paper p="md" radius="md" withBorder bg="#141517">
    
                              <Title order={6} mb="sm" c="white">{t('install_widget')}</Title>
    
                              <Box p="xs" bg="#1a1b1e" style={{ borderRadius: '6px', border: '1px solid #333', position: 'relative' }}>
    
                                <Text size="xs" component="pre" style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all', paddingRight: '20px', color: '#a1a1aa' }}>
    
                                  {`<iframe src="https://ailinkb.com/widget?token=${window.btoa(authEmail)}" style="width: 350px; height: 550px; border: none; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);"></iframe>`}
    
                                </Text>
    
                                <ActionIcon size="sm" variant="subtle" style={{ position: 'absolute', top: 5, right: 5 }} onClick={() => { navigator.clipboard.writeText(`<iframe src="https://ailinkb.com/widget?token=${window.btoa(authEmail)}" style="width: 350px; height: 550px; border: none; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);"></iframe>`); alert(t('copy') + "!"); }}><IconCopy size={14}/></ActionIcon>
    
                              </Box>
    
    
    
                              <Title order={6} mt="md" mb="sm" c="white">{t('profile_link')}</Title>
    
                              <Group gap="xs" wrap="nowrap">
    
                                <TextInput 
    
                                  size="xs" 
    
                                  readOnly 
    
                                  value={`https://ailinkb.com/?profile=${window.btoa(authEmail)}`} 
    
                                  style={{ flexGrow: 1 }} 
    
                                />
    
                                <Button size="xs" variant="light" onClick={() => { navigator.clipboard.writeText(`https://ailinkb.com/?profile=${window.btoa(authEmail)}`); alert(t('copy') + "!"); }}>{t('copy')}</Button>
    
                              </Group>
    
                              <Box mt="md" ta="center">
    
                                <Text size="xs" c="dimmed" mb="xs">Scan to view profile:</Text>
    
                                <Paper p="xs" radius="md" style={{ display: 'inline-block', border: '1px solid #333' }}>
    
                                  <QRCodeSVG value={`https://ailinkb.com/?profile=${window.btoa(authEmail)}`} size={120} />
    
                                </Paper>
    
                              </Box>
    
                            </Paper>
    
                          )}
    
                        </Box>
    
                      </Grid.Col>
    
                    </Grid>
    
                  </Container>
    
    
    
                  <Modal opened={termsModalOpened} onClose={() => setTermsModalOpened(false)} title={t('privacy_policy_title')} size="lg">
    
                    <ScrollArea h={400} p="md"><Stack gap="md">
    
                      <Title order={4}>{t('privacy_policy_title')}</Title>
    
                      <Text size="sm" style={{ whiteSpace: 'pre-line' }}>{t('privacy_policy_content')}</Text>    
                    </Stack></ScrollArea>    
                    <Button fullWidth mt="md" onClick={() => { setTermsAccepted(true); setTermsModalOpened(false); }}>Accept</Button>    
                  </Modal>    
                </form>    
              </Box>    
            );    
          };

export default WebsiteBuilderTab;

